import React, { useContext, useRef } from "react";
import Hero from "../Hero";
import Solutions from "../Solutions";
import Service from "../Service";
import Challenge from "../Challenge";
import HeroChild from "./HeroChild";
import AnimImg from "./anim/AnimImg";
import { data } from "./data";
import { animation, preAnimate, afterAnimate } from "./anim/animation";
import "./index.css";
import { LandingsAnimationContext } from "../../../context/LandingsAnimationContext";
import TextChild from "../TextChild";
import TextWithTitleChild from "../TextWithTitleChild";
import ListChild from "../ListChild";

const Grammarly = () => {
  const {
    isGrammarlyAnimationStarted,
    setIsGrammarlyAnimationStarted,
    isGrammarlyAnimationFinished,
    setIsGrammarlyAnimationFinished,
  } = useContext(LandingsAnimationContext);
  const ref = useRef(null);
  return (
    <div className="grammarly" ref={ref}>
      <Challenge
        heroTitle={data.hero.title}
        heroSubTitle={data.hero.subtitle}
        challengeTitle={data.challenge.title}
        sctRef={ref}
        animation={animation}
        preAnimate={preAnimate}
        afterAnimate={afterAnimate}
        isStarted={isGrammarlyAnimationStarted}
        setIsStarted={setIsGrammarlyAnimationStarted}
        isFinished={isGrammarlyAnimationFinished}
        setIsFinished={setIsGrammarlyAnimationFinished}
      >
        <AnimImg />
        <TextChild text={data.hero.text} />
        <TextWithTitleChild articles={data.challenge.articles} />
      </Challenge>
      <Hero title={data.hero.title} subtitle={data.hero.subtitle}>
        <TextChild text={data.hero.text} />
        <HeroChild />
      </Hero>
      <Solutions
        title={data.solutions.title}
        text={data.solutions.text}
        image={data.solutions.image}
        bgr={data.solutions.bgr}
      >
        <ListChild lists={data.solutions.lists} />
      </Solutions>
      <Service image={data.service.image} />
    </div>
  );
};

export default Grammarly;
